import { ServiceConfig } from '@sales-center/common'
import { PaymentMethod } from '@user/store/payments'
import { get } from '@user/store/services/crud'
import { externalAppTimeoutError } from '@user/store/utilities/functions'
import { useEffect, useState } from 'react'

type Props = {
  externalLocationId: string
}

type State = {
  loading: boolean
  rows: PaymentMethod[]
}

export function useData(props: Props) {
  const { externalLocationId } = props
  const [state, setState] = useState<State>({
    loading: true,
    rows: [],
  })

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (mounted) {
        const baseUrl = `${ServiceConfig.baseAPIUrl}/Payment`

        const response = await get(`${baseUrl}/${externalLocationId}`)

        if (response.ok) {
          const payload: PaymentMethod[] = await response.json()
          setState({ loading: false, rows: payload })
        } else {
          setState({ loading: false, rows: [] })
          externalAppTimeoutError(response)
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [externalLocationId])

  return {
    ...state,
  }
}
